import { useMemo } from 'react';
import type { PromoPlacement, PromoBase } from '../../shared/promoConfig';
import { getPromoCopy } from '../../shared/promoConfig';
import { usePromoAttribution } from '@/hooks/usePromoAttribution';

export const usePromoCopy = (placement: PromoPlacement): PromoBase | null => {
  const attribution = usePromoAttribution();

  return useMemo(() => {
    const ref = attribution?.ref || attribution?.utm_source || null;
    return getPromoCopy(placement, { ref });
  }, [placement, attribution?.ref, attribution?.utm_source]);
};
